/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  fetch_user_contact_details_action,
  check_microsoft_auth_action,
  fetch_microsoft_email_threads_action,
} from '../../_redux/action';

function useViewContact() {
  const [loading, setLoading] = useState(true);
  const [microsoftEmailThreadsLoading, setMicrosoftEmailThreadsLoading] = useState(false);
  const [contactDetails, setContactDetails] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);
  const [activeTab, setActiveTab] = useState('inbox');
  const [emailThreads, setEmailThreads] = useState([]);
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { contactData } = useSelector((state) => state.fetch_user_contact_details_reducer);
  const { emailThreadsData } = useSelector((state) => state.fetch_microsoft_email_threads_reducer);
  const { is_microsoft_connected } = useSelector((state) => state.check_microsoft_auth_reducer);

  useEffect(() => {
    if (id) {
      fetchContact();
    }
  }, [id]);

  useEffect(() => {
    if (contactData) {
      setContactDetails(contactData);
    }
  }, [contactData]);

  useEffect(() => {
    if (contactDetails) {
      checkMicrosoftAuth();
    }
  }, [contactDetails]);

  useEffect(() => {
    if (is_microsoft_connected?.is_connected) {
      fetchMicrosoftEmailThreads();
    }
  }, [is_microsoft_connected]);

  const checkMicrosoftAuth = async () => {
    setMicrosoftEmailThreadsLoading(true);
    await dispatch(check_microsoft_auth_action());
    setMicrosoftEmailThreadsLoading(false);
  };

  const fetchMicrosoftEmailThreads = async () => {
    setMicrosoftEmailThreadsLoading(true);
    await dispatch(fetch_microsoft_email_threads_action(id));
    setMicrosoftEmailThreadsLoading(false);
  };

  const fetchContact = async () => {
    setLoading(true);
    await dispatch(fetch_user_contact_details_action(id));
    setLoading(false);
  };

  const onGoBackClick = () => {
    navigate(-1);
  };

  const handleContactModalOpen = (item) => {
    if (contactModalOpen) {
      fetchContact();
    }
    setContactModalOpen((v) => !v);
  };

  const handleDeleteModalOpen = (item) => {
    if (deleteModalOpen) {
      onGoBackClick();
    }
    setDeleteModalOpen((prev) => !prev);
  };

  const tabChangeHandler = (key) => {
    setActiveTab(key);

    if (key === 'inbox') {
      setEmailThreads(emailThreadsData?.inbox);
    } else {
      setEmailThreads(emailThreadsData?.sent);
    }
  };

  return {
    deleteModalOpen,
    contactModalOpen,
    is_microsoft_connected,
    contactDetails,
    loading,
    microsoftEmailThreadsLoading,
    handleContactModalOpen,
    handleDeleteModalOpen,
    tabChangeHandler,
    activeTab,
    emailThreads,
  };
}

export default useViewContact;
